import React, { useEffect, useState } from 'react';
import BulletinForm from './BulletinForm';
import { useSiteSettings } from '../../context/SiteSettingsContext';

const COOKIE_KEY = 'bulletin_popup_seen';
const COOKIE_EXPIRE_DAYS = 365;

const setCookie = (name, value, days) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
};

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
};

const FirstVisitPopup = () => {
  const { eBulletinActive, settingsLoaded } = useSiteSettings();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!settingsLoaded || !eBulletinActive) return;
    // Cookie yoksa popup göster
    if (!getCookie(COOKIE_KEY)) {
      // Sayfa yüklendinken 1.5 saniye sonra göster
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, [settingsLoaded, eBulletinActive]);

  const dismiss = () => {
    setCookie(COOKIE_KEY, '1', COOKIE_EXPIRE_DAYS);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 transition-opacity"
        onClick={dismiss}
        aria-hidden="true"
      />

      {/* Modal */}
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="bulletin-popup-title"
        className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none"
      >
        <div className="relative bg-white dark:bg-gray-800 rounded-2xl shadow-2xl
          w-full max-w-md pointer-events-auto
          animate-[fadeInUp_0.3s_ease-out]">

          {/* Kapatma butonu */}
          <button
            onClick={dismiss}
            aria-label="Kapat"
            className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center
              rounded-full text-gray-400 hover:text-gray-600 dark:hover:text-gray-200
              hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          {/* İkon */}
          <div className="flex justify-center pt-8 pb-2">
            <div className="w-16 h-16 bg-blue-100 dark:bg-blue-900/50 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-blue-600 dark:text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
          </div>

          {/* İçerik */}
          <div className="px-6 pb-6 pt-3">
            <h2
              id="bulletin-popup-title"
              className="text-xl font-bold text-gray-900 dark:text-white text-center mb-2"
            >
              E-Bülten Aboneliği
            </h2>
            <p className="text-gray-500 dark:text-gray-400 text-sm text-center mb-5 leading-relaxed">
              En güncel haberleri, gelişmeleri ve özel içerikleri doğrudan e-posta
              kutunuzda almak ister misiniz?
            </p>

            <BulletinForm compact variant="popup" />

            <button
              onClick={dismiss}
              className="mt-4 w-full text-center text-xs text-gray-400 hover:text-gray-600
                dark:hover:text-gray-300 transition-colors py-1"
            >
              Hayır, teşekkürler
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FirstVisitPopup;
